/**
 * 按需加载非 Inter 的工作区字体；入口 main.tsx 仅同步加载 Inter。
 * 编辑器区域：等宽 + 中文 UI 正文字重。
 * 预览/阅读：衬线阅读栈对应字重。
 */
let editorFontsPromise: Promise<void> | null = null
let readingFontsPromise: Promise<void> | null = null
const shouldSkipDynamicFontLoading = Boolean(import.meta.env.VITEST)

export function ensureEditorFonts(): Promise<void> {
  if (shouldSkipDynamicFontLoading) {
    return Promise.resolve()
  }
  if (!editorFontsPromise) {
    editorFontsPromise = Promise.all([
      import('@fontsource/jetbrains-mono/400.css'),
      import('@fontsource/jetbrains-mono/500.css'),
      import('@fontsource/noto-sans-sc/400.css'),
      import('@fontsource/noto-sans-sc/500.css'),
      import('@fontsource/noto-sans-sc/600.css'),
    ]).then(() => undefined)
  }
  return editorFontsPromise
}

export function ensureReadingFonts(): Promise<void> {
  if (shouldSkipDynamicFontLoading) {
    return Promise.resolve()
  }
  if (!readingFontsPromise) {
    readingFontsPromise = Promise.all([
      import('@fontsource-variable/source-serif-4'),
      import('@fontsource/noto-serif-sc/400.css'),
      import('@fontsource/noto-serif-sc/600.css'),
    ]).then(() => undefined)
  }
  return readingFontsPromise
}
